import { useState } from 'react';
import {
	TransmiseListWhereInput,
	useLazyTransmiseListQuery,
} from '../../../graphql/graphql';

export default function useTransmise() {
	const [getData, { data, isLoading }] = useLazyTransmiseListQuery();
	const [page, setPage] = useState(1);

	const getFlatTransmiseList = (filter: TransmiseListWhereInput) => {
		getData({
			where: filter,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getFlatTransmiseList,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
